import { createStructuredSelector } from 'reselect'

import {
  AUTOREVIEW_DETAIL,
  AUTOREVIEW_DETAIL_SUCCESS,
  AUTOREVIEW_DETAIL_ERROR,
  AUTOREVIEW_ADD_SET,
  AUTOREVIEW_ADD_CHANGE,
  AUTOREVIEW_EDIT_MODAL_SET,
  AUTOREVIEW_ADD_MODAL_SET,
  AUTOREVIEW_EDIT_TAB_SET,
  AUTOREVIEW_SEARCH,
  AUTOREVIEW_SEARCH_SUCCESS,
  AUTOREVIEW_SEARCH_ERROR,
  AUTOREVIEW_ADD,
  AUTOREVIEW_ADD_SUCCESS,
  AUTOREVIEW_ADD_ERROR,
  AUTOREVIEW_HEADER,
  AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST,
  AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST_SUCCESS,
  AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST_ERROR,
  AUTOREVIEW_SEARCH_SUPPLIER_LIST,
  AUTOREVIEW_SEARCH_SUPPLIER_LIST_SUCCESS,
  AUTOREVIEW_SEARCH_SUPPLIER_LIST_ERROR,
  AUTOREVIEW_LIST,
  AUTOREVIEW_LIST_SUCCESS,
  AUTOREVIEW_LIST_ERROR,
  AUTOREVIEW_SEARCH_SET,
  AUTOREVIEW_SEARCH_CHANGE,
  AUTOREVIEW_PAGE_SET,
  AUTOREVIEW_VIEW_MODAL_SET,
  AUTOREVIEW_VIEW_DETAIL_MODAL_SET,
  AUTOREVIEW_VIEW_SET,
  AUTOREVIEW_VIEW_TAB_SET,
  AUTOREVIEW_EDIT_CHANGE,
  AUTOREVIEW_UPDATE,
  AUTOREVIEW_UPDATE_SUCCESS,
  AUTOREVIEW_UPDATE_ERROR
} from '../actions';

export const NAME = 'autoreview';

export const AutoReviewDetail = (data) => ({
  type: AUTOREVIEW_DETAIL,
  payload: data
});

export const AutoReviewDetailSuccess = (data) => ({
  type: AUTOREVIEW_DETAIL_SUCCESS,
  payload: data
});

export const AutoReviewDetailError = (error) => ({
  type: AUTOREVIEW_DETAIL_ERROR,
  payload: error
});

export const AutoReviewAddSet = (data) => ({
  type: AUTOREVIEW_ADD_SET,
  payload: data
});

export const AutoReviewAddChangeSet = (data) => ({
  type: AUTOREVIEW_ADD_CHANGE,
  payload: data
});

export const AutoReviewEditModalSet = (data) => ({
  type: AUTOREVIEW_EDIT_MODAL_SET,
  payload: data
});

export const AutoReviewAddModalSet = (data) => ({
  type: AUTOREVIEW_ADD_MODAL_SET,
  payload: data
});

export const AutoReviewEditTabSet = (data) => ({
  type: AUTOREVIEW_EDIT_TAB_SET,
  payload: data
});

export const AutoReviewViewTabSet = (data) => ({
  type: AUTOREVIEW_VIEW_TAB_SET,
  payload: data
});

export const AutoReviewSearch = (data) => ({
  type: AUTOREVIEW_SEARCH,
  payload: data
});

export const AutoReviewSearchSuccess = (data) => ({
  type: AUTOREVIEW_SEARCH_SUCCESS,
  payload: data
});

export const AutoReviewSearchError = (error) => ({
  type: AUTOREVIEW_SEARCH_ERROR,
  payload: error
});

export const AutoReviewAdd = (data) => ({
  type: AUTOREVIEW_ADD,
  payload: data
});

export const AutoReviewAddSuccess = (data) => ({
  type: AUTOREVIEW_ADD_SUCCESS,
  payload: data
});

export const AutoReviewAddError = (error) => ({
  type: AUTOREVIEW_ADD_ERROR,
  payload: error
});

export const AutoReviewHeader = (data) => ({
  type: AUTOREVIEW_HEADER,
  payload: data
});

export const AutoReviewSearchAutoReviewStateList = () => ({
  type: AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST
});

export const AutoReviewSearchAutoReviewStateListSuccess = (message) => ({
  type: AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST_SUCCESS,
  payload: message
});

export const AutoReviewSearchAutoReviewStateListError = (error) => ({
  type: AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST_ERROR,
  payload: error
});

export const AutoReviewSearchSupplierList = () => ({
  type: AUTOREVIEW_SEARCH_SUPPLIER_LIST
});

export const AutoReviewSearchSupplierListSuccess = (message) => ({
  type: AUTOREVIEW_SEARCH_SUPPLIER_LIST_SUCCESS,
  payload: message
});

export const AutoReviewSearchSupplierListError = (error) => ({
  type: AUTOREVIEW_SEARCH_SUPPLIER_LIST_ERROR,
  payload: error
});

export const AutoReviewList = (page, num_page, orderBy, filters, stateFilter) => ({
  type: AUTOREVIEW_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const AutoReviewListSuccess = (data) => ({
  type: AUTOREVIEW_LIST_SUCCESS,
  payload: data
});

export const AutoReviewListError = (error) => ({
  type: AUTOREVIEW_LIST_ERROR,
  payload: error
});

export const AutoReviewSearchSet = (data) => ({
  type: AUTOREVIEW_SEARCH_SET,
  payload: data
});

export const AutoReviewSearchChangeSet = (data) => ({
  type: AUTOREVIEW_SEARCH_CHANGE,
  payload: data
});

export const AutoReviewPageSet = (data) => ({
  type: AUTOREVIEW_PAGE_SET,
  payload: data
});

export const AutoReviewViewModalSet = (data) => ({
  type: AUTOREVIEW_VIEW_MODAL_SET,
  payload: data
});

export const AutoReviewViewDetailModalSet = (data) => ({
  type: AUTOREVIEW_VIEW_DETAIL_MODAL_SET,
  payload: data
});


export const AutoReviewViewSet = (data) => ({
  type: AUTOREVIEW_VIEW_SET,
  payload: data
});

export const AutoReviewEditChangeSet = (data) => ({
  type: AUTOREVIEW_EDIT_CHANGE,
  payload: data
});

export const AutoReviewUpdate = (data) => ({
  type: AUTOREVIEW_UPDATE,
  payload: data
});

export const AutoReviewUpdateSuccess = (message) => ({
  type: AUTOREVIEW_UPDATE_SUCCESS,
  payload: message.message
});

export const AutoReviewUpdateError = (error) => ({
  type: AUTOREVIEW_UPDATE_ERROR,
  payload: error
});

const autoreview = (state) => state[NAME];
export const AutoReviewSelector = createStructuredSelector({
  autoreview
})
